import { FC, useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import History from './History';
import Associate from './Associate';
import { MenteeEditContext } from '..';
import Refused from './Refused';
import OngoingMentorship from './Ongoing';
import MenteeTracking from './tracking';

const MenteeMentoringRoutes: FC = () => {
  const { mentee } = useContext(MenteeEditContext);

  return (
    <Routes>
      <Route
        path="/"
        element={
          mentee?.menteeStatus === 'MENTORSHIP_ACTIVE' ? (
            <OngoingMentorship />
          ) : mentee?.menteeStatus === 'REFUSED' ? (
            <Refused />
          ) : (
            <Associate />
          )
        }
      />

      <Route path="/history/" element={<History />} />
      <Route path="/tracking/" element={<MenteeTracking />} />
    </Routes>
  );
};

export default MenteeMentoringRoutes;
